import base from './base'

export const getUser = () => base.get('/user')
    .then(res => res.data)


// WEBPACK FOOTER //
// ./src/services/user.js